<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          Images ({{ keys.length }}/{{ maxVariables }}):
          <br />
          <span class="disclaimer">Up to 20 images per size. Required sizes:</span>
          <br />
          <span class="disclaimer">1) 1200x628 &ndash; up to 20, 4+ recommended</span>
          <br />
          <span class="disclaimer">2) 1200x1200 &ndash; up to 20, 4+ recommended</span>
          <br />
          <span class="disclaimer">3) 960x1200 &ndash; up to 20, 2+ recommended</span>
          <br />
          <span class="disclaimer">Max file size: 5 MB. Formats: JPG, PNG.</span>
          <br />
          <span class="disclaimer">
            Keep content within the central 80% of the image &ndash; the safe
            area that is never cropped, whatever the screen size.
          </span>
        </div>
      </div>

      <!-- START: Per-size counter -->
      <div class="size-counts mb-3">
        <div
          *ngFor="let size of sizeCounts"
          class="size-count"
          [class.size-count-over]="size.count > size.max"
        >
          {{ size.label }}: {{ size.count }}/{{ size.max }}
          <span *ngIf="size.count > size.max">
            <i class="bi bi-exclamation-triangle-fill"></i>
            over the limit, remove {{ size.count - size.max }}
          </span>
          <span
            *ngIf="size.count < size.recommended"
            class="size-count-hint"
          >
            ({{ size.recommended }}+ recommended)
          </span>
        </div>
      </div>
      <!-- END: Per-size counter -->

      <div class="row">
        <div class="col-12" *ngFor="let pmaxImageKey of keys">
          <app-block-text
            [type]="'link'"
            [isPlainText]="true"
            (handleOnChange)="onChange($event, pmaxImageKey)"
            (handleVariableRemoval)="variableRemoval($event)"
            [blockData]="block.variables?.[pmaxImageKey] ?? ''"
            [maxLength]="4000"
            [variable]="pmaxImageKey"
            [isSubBlockDeletable]="true"
            [isImage]="true"
          ></app-block-text>
        </div>
        <div class="col-12 mt-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="add()"
            [disabled]="!canAdd"
          >
            <i class="bi bi-plus-lg"></i>Add image
          </button>
        </div>
      </div>
    </div>
  </div>
</main>
